<template>
  <div class="flex flex-col items-center p-4 bg-white border-2 rounded">
    <img :src="product.photo" width="100" height="100" alt="Producto" />
    <h3 class="text-lg font-medium text-center">{{ product.name }}</h3>
    <p class="text-gray-500 text-xs">{{ product.code }}</p>
    
    <!-- Para productos de recargas y planes en Bs -->
    <template v-if="isRecarga">
      <div class="my-1.5 text-center">
        <span class="inline-block px-2 py-0.5 bg-emerald-100 text-emerald-800 text-xs font-bold rounded">
          Monto en Bs.
        </span>
        <p class="text-gray-500 text-xs mt-1" v-if="isPlan">Planes en Bs. (editable en carrito)</p>
        <p class="text-gray-500 text-xs mt-1" v-else>Monto libre en Bs. en carrito</p>
      </div>
    </template>
    
    <!-- Para productos estándar en USD -->
    <template v-else>
      <p class="text-gray-500" v-if="product?.prices?.length">${{ Number(product?.prices[0]['price'] || 0).toFixed(2) }}</p>
      <p class="text-gray-500" v-if="product?.prices?.length">BsD.{{ (Number(product?.prices[0]['price'] || 0) * change).toFixed(2) }}</p>
      <p class="text-gray-500" v-if="product?.prices?.length && cop_change">Cop.{{ ((Number(product?.prices[0]['price'] || 0) * change) * cop_change).toFixed(1) }}</p>
    </template>

    <p class="text-gray-500 text-xs mt-1">{{ product?.quantity }} disponibles</p>
    <button @click="addProduct(product)" class="mt-2 px-4 py-2 text-white font-bold bg-blue-500 hover:bg-blue-700 rounded text-sm w-full">
      Agregar al carrito
    </button>
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
    change: Number,
    cop_change: Number
  },
  computed: {
    cleanCode() {
      return (this.product?.code || '').replace(/[\s\-_.]/g, '').toUpperCase()
    },
    isPlan() {
      return this.cleanCode === 'RECARGAPLANES' || this.cleanCode === 'RECARGA2'
    },
    isRecarga() {
      return this.isPlan || this.cleanCode === 'RECARGAVTA' || this.cleanCode === 'RECARGAREEMPLAZO'
    }
  },
  methods: {
    addProduct(product) {
      this.$emit('addCart', product);
    }
  }
}
</script>
